import {
  CheckoutBillingFields,
} from '../components/AdyenCheckoutBillingForm/AdyenCheckoutBillingForm';

export const DELAY_ERROR = 1000;

export const MAXIMUM_CARDS_QUANTITY = 5000;

export const MAXIMUM_COMPANY_NAME_LENGTH = 200;
export const MAXIMUM_NAME_LENGTH = 50;

export enum CreditCardType {
  AMERICAN_EXPRESS = 'american_express',
  DANKORT = 'dankort',
  DINERS = 'diners',
  DISCOVER = 'discover',
  ELECTRON = 'electron',
  INTERPAYMENT = 'interpayment',
  JCB = 'jcb',
  MAESTRO = 'maestro',
  MASTERCARD = 'mastercard',
  UNIONPAY = 'unionpay',
  VISA = 'visa',
}

export enum SupportedCreditCardTypes {
  Visa = CreditCardType.VISA,
  MasterCard = CreditCardType.MASTERCARD,
  AmericanExpress = CreditCardType.AMERICAN_EXPRESS,
}

export const defaultBillingFields: CheckoutBillingFields = {
  postCode: '',
  city: '',
  street: '',
  houseNumber: '',
  addressLine1: '',
  addressLine2: '',
  suffix: '',
};

export const JSON_PAYMENT_GATEWAY_ID = 'buckaroo_json_credit_card';
export const APPLE_PAY_PAYMENT_GATEWAY_ID = 'buckaroo_json_apple_pay_';
export const ADYEN_CREDIT_CARD_PAYMENT_GATEWAY_ID = 'adyen_credit_card';
export const ADYEN_APPLE_PAY_PAYMENT_GATEWAY_ID = 'adyen_apple_pay';
export const ADYEN_GOOGLE_PAY_PAYMENT_GATEWAY_ID = 'adyen_google_pay';
export const ADYEN_EPS_PAYMENT_GATEWAY_ID = 'adyen_eps';
export const ADYEN_BLIK_PAYMENT_GATEWAY_ID = 'adyen_blik';
export const ADYEN_PRZELEWY_PAYMENT_GATEWAY_ID = 'adyen_online_banking_poland';
export const ADYEN_PAYPAL_PAYMENT_GATEWAY_ID = 'adyen_paypal';
export const ADYEN_MOBILEPAY_PAYMENT_GATEWAY_ID = 'adyen_mobile_pay';
export const ADYEN_TRUSTLY_PAYMENT_GATEWAY_ID = 'adyen_trustly';
export const ADYEN_MBWAY_PAYMENT_GATEWAY_ID = 'adyen_mb_way';
